import { authorizedAPI } from "@/config/axios.config";
import { UtilsService } from "../utils";

const utils = new UtilsService();

// Creation payload for processed application
export interface formDataTypes{
    applicantProcessId: string;
    formId: string;
    reviewerId: string;
    responses: any;
}

class ProcessedApplicationsService {
    createProcessedApplication(formData: formDataTypes): Promise<any> {
        return utils.handleApiRequest(() => authorizedAPI.post('/processed-applications', formData));
    }
}

export const processedApplicationsService = new ProcessedApplicationsService();
